<template>
  <section class="section">
    <slot />
  </section>
</template>

<script>
export default {
  name: "Section"
};
</script>

<style scoped>
.section {
  @apply p-4 max-w-6xl mx-auto;

  @screen sm {
    @apply p-6;
  }

  @screen md {
    @apply p-10;
  }
}
</style>
